import { ReactNode } from 'react';

import QuestionCircleIcon from '@/assets/question-circle.svg?react';
import cn from '@/utils/cn';

interface CheckoutSummaryNoteProps {
  children: ReactNode;
  className?: string;
}

const CheckoutSummaryNote = ({
  children,
  className,
}: CheckoutSummaryNoteProps) => {
  return (
    <div
      className={cn(
        'flex w-full items-center gap-2 rounded-md bg-gray-200 p-3.5 md:p-6',
        className
      )}
    >
      <QuestionCircleIcon width={16} className="shrink-0 text-primary" />
      <p className="caption-large flex-1 text-dark-gray-500 lg:text-oxford-blue-300">
        {children}
      </p>
    </div>
  );
};

export default CheckoutSummaryNote;
